import { Action, NgxsOnInit, State, StateContext, Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { CheckVersion } from './version.actions';
import { StateReset } from 'ngxs-reset-plugin';
import { environment } from '../../../environments/environment';
import { JWT_STORAGE_KEY } from '@services/auth.service';
import {
  ContractorLoginAtKey,
  ContractorPinKey,
  ContractorShortCodeKey,
} from '@services/contractor-credentials.service';

interface VersionStateModel {
  version?: string
}

const SESSION_LOCAL_STORAGE_KEYS = [JWT_STORAGE_KEY];
const SESSION_SESSION_STORAGE_KEYS = [ContractorShortCodeKey, ContractorPinKey, ContractorLoginAtKey];

function clearStorageExcept(storage: Storage, keptKeys: string[]): void {
  for (let i = storage.length - 1; i >= 0; i--) {
    const key = storage.key(i);
    if (key !== null && !keptKeys.includes(key)) {
      storage.removeItem(key);
    }
  }
}

@State<VersionStateModel>({
  name: 'version',
  defaults: {
    version: undefined,
  },
})
@Injectable()
export class VersionState implements NgxsOnInit {
  private readonly store = inject(Store);

  ngxsOnInit(): void {
    this.store.dispatch(new CheckVersion());
  }

  @Action(CheckVersion)
  async checkVersion(ctx: StateContext<VersionStateModel>): Promise<void> {
    const storedVersion = ctx.getState().version;
    const currentVersion = environment.storeVersion;

    if (storedVersion === currentVersion) {
      return;
    }
    if (storedVersion !== undefined) {
      await this.store.dispatch(new StateReset());
      clearStorageExcept(window.localStorage, SESSION_LOCAL_STORAGE_KEYS);
      clearStorageExcept(window.sessionStorage, SESSION_SESSION_STORAGE_KEYS);
    }
    ctx.patchState({
      version: currentVersion,
    });
  }
}
